import React from 'react';
import HistoryItem from '../../../Das/Manage/NonFungible/History/Item';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import defaultStyles from './Default.scss';
export var DasInfo = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var deviation = _a.deviation;
    var hasDas = useFlag('digital_assets');
    if (!hasDas || ((_b = deviation === null || deviation === void 0 ? void 0 : deviation.digitalAsset) === null || _b === void 0 ? void 0 : _b.hasEditions)) {
        return null;
    }
    return (React.createElement("div", { className: defaultStyles['subject'] },
        React.createElement("div", { className: defaultStyles['detail-group-title'] }, "Digital Asset History"),
        ((_e = (_d = (_c = deviation.extended) === null || _c === void 0 ? void 0 : _c.digitalAsset) === null || _d === void 0 ? void 0 : _d.history) === null || _e === void 0 ? void 0 : _e.entries) && (React.createElement("div", { role: "list" }, (_h = (_g = (_f = deviation.extended) === null || _f === void 0 ? void 0 : _f.digitalAsset) === null || _g === void 0 ? void 0 : _g.history) === null || _h === void 0 ? void 0 : _h.entries.map(function (item) { return (React.createElement(HistoryItem, { key: item.txId, item: item })); })))));
};
DasInfo.displayName = 'DasInfo';
export default DasInfo;
//# sourceMappingURL=DasInfo.js.map